import { Scissors, Sprout, Apple, Layers, Snowflake } from 'lucide-react';
import { formatTimeRange } from '../../utils/carePhaseUtils';

const CARE_TYPE_CONFIG = {
  pruning: { Icon: Scissors, colorClass: 'text-emerald-500' },
  planting: { Icon: Sprout, colorClass: 'text-emerald-500' },
  harvest: { Icon: Apple, colorClass: 'text-amber-500' },
  mulching: { Icon: Layers, colorClass: 'text-amber-700' },
  winter_protection: { Icon: Snowflake, colorClass: 'text-blue-400' },
};

/**
 * CareTypeGroup — displays one care type (e.g. "Schnitt") with all affected
 * plants and their formatted time ranges.
 */
const CareTypeGroup = ({ type, label, plants }) => {
  const config = CARE_TYPE_CONFIG[type] ?? { Icon: Sprout, colorClass: 'text-emerald-500' };
  const { Icon, colorClass } = config;

  return (
    <div className="py-3 border-b border-gray-100 last:border-0">
      <div className="flex items-center gap-2 mb-2">
        <Icon size={16} className={colorClass} aria-hidden="true" />
        <span className="text-sm font-medium text-gray-900">{label}</span>
      </div>
      <ul className="flex flex-col gap-1 pl-6">
        {plants.map(({ plant, timeRange }) => (
          <li key={plant.id ?? plant.scientific_name} className="text-[13px] text-gray-700">
            {plant.name || plant.scientific_name}
            {timeRange && (
              <span className="text-gray-500"> · Empfohlener Zeitraum: {formatTimeRange(timeRange)}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CareTypeGroup;
